<template>
  <div id="pk-result2">
      <div class="award-tab-wrapper">
          <button :class="awardType === 'team' ? 'active' : ''" @click="awardType = 'team'">战队奖项</button>
          <button :class="awardType === 'person' ? 'active' : ''" @click="awardType = 'person'">个人奖项</button>
      </div>
      <div v-show="awardType === 'team'" class="team">
        <p class="intro">团队奖项将在活动结束后的次日开奖，活动期间会进行结果的预统计，以便战队成员了解最新的战况。</p>
        <div class="award-info-team">
              <h2 v-if="teamTime !== 0" class="time">开奖时间：{{ teamTime | parseTime}}</h2>
              <div v-else class="title-box">
                <img src="@/assets/active/team-pk/title-tag.png" alt="">
                <span>当前预计统计结果</span>
                <img src="@/assets/active/team-pk/title-tag.png" alt="">
              </div>
              <div class="award-card">
                  <div class="card-head card-row">
                    <span class="rank">名次</span>
                    <span class="name">获奖战队</span>
                    <span class="content">战队奖励</span>
                  </div>
                  <div class="card-body card-row">
                    <span class="rank">
                        <div>
                            <img src="@/assets/active/team-pk2/result/1.png" alt="">
                        </div>
                        <h3>一等奖</h3>
                    </span>
                    <span class="name">
                        <div>
                            <p class="team-name">{{ teamObj.one.name }}</p>
                        </div>
                    </span>
                    <span class="content">
                        <p v-html="teamObj.one.content"></p>
                    </span>
                  </div>
                  <div class="card-body card-row">
                    <span class="rank">
                        <div>
                            <img src="@/assets/active/team-pk2/result/2.png" alt="">
                        </div>
                        <h3>二等奖</h3>
                    </span>
                    <span class="name">
                        <div>
                            <p class="team-name">{{ teamObj.two ? teamObj.two.name : '-' }}</p>
                        </div>
                    </span>
                    <span class="content">
                        <p v-html="teamObj.two ? teamObj.two.content : '-'"></p>
                    </span>
                  </div>
                  <div class="card-body card-row">
                    <span class="rank">
                        <div>
                            <img src="@/assets/active/team-pk2/result/3.png" alt="">
                        </div>
                        <h3>三等奖</h3>
                    </span>
                    <span class="name">
                        <div>
                            <p class="team-name">{{ teamObj.three ? teamObj.three.name : '-' }}</p>
                        </div>
                    </span>
                    <span class="content">
                        <p v-html="teamObj.three ? teamObj.three.content : '-'"></p>
                    </span>
                  </div>
                  <div class="line first"></div>
                  <div class="line second"></div>
              </div>
              <p class="update-time">更新时间：{{updateTime | parseTime}}</p>
          </div>
      </div>
      <div v-show="awardType === 'person'" class="person">
          <p class="intro">最强王者奖将在活动结束后的次日开奖，活动期间将会每天更新个人收益率榜单，连续三天蝉联个人收益率冠军的用户将获得最强王者奖，赢得<span>88 USDT</span>奖励</p>
          <div class="award-info-person">
              <h2 v-if="state === 'D'" class="person-time">开奖时间：{{ teamTime | parseTime }}</h2>
              <h2 v-if="state === 'D' && !(personAward && personAward.length > 0)" class="person-time">奖品未开出，没有达标用户</h2>
              <div v-if="state === 'D' && personAward && personAward.length > 0" class="award-card">
                  <div class="card-head card-row">
                    <span class="name">获奖用户</span>
                    <span class="days">获奖天数</span>
                    <span class="content">奖金</span>
                  </div>
                  <div v-for="item in personAward" :key="item.id" class="card-body card-row">
                    <span class="name">
                        <div>
                            <img class="ava" :src="item.memberInfo.headImg ? item.memberInfo.headImg : defaultImg " alt="">
                            <p class="id">{{ item.memberInfo ? item.memberInfo.jgzUserId : '-' }}</p>
                            <p class="nick">{{ item.memberInfo ? item.memberInfo.nickName : '-' }}</p>
                        </div>
                    </span>
                    <span class="days">{{ item.attr }}</span>
                    <span class="content" v-html="item.content"></span>
                  </div>
                  <p class="line first"></p>
                  <p class="line second"></p>
              </div>
              <div class="award-list">
                    <div class="title-box">
                        <img src="@/assets/active/team-pk/title-tag.png" alt="">
                        <span>个人收益率榜单</span>
                        <img src="@/assets/active/team-pk/title-tag.png" alt="">
                    </div>
                    <div class="list-wrapper">
                        <div class="list-head clearfix">
                            <div class="date-time left">
                                <span>统计日期</span>
                            </div>
                            <div class="name-part left">
                                <span>收益率冠军</span>
                            </div>
                            <div class="incomeRate left">
                                <span>个人收益率</span>
                            </div>
                        </div>
                        <div class="list-body">
                            <ul>
                                <li v-for="item in personList" :key="item.id" class="clearfix">
                                    <div class="date-time left">
                                        <span>{{ item.timestamp | parseTime("{m}-{d}") }}</span>
                                    </div>
                                    <div class="name-part left">
                                        <div class="name-box">
                                            <img class="ava" :src="item.memberInfo.headImg ? item.memberInfo.headImg : defaultImg" alt="" />
                                            <p class="u-id">{{ item.memberInfo.jgzUserId }}</p>
                                            <p class="u-name">{{ item.memberInfo.nickName ? item.memberInfo.nickName : '-' }}</p>
                                        </div>
                                    </div>
                                    <div class="incomeRate left">
                                        <span>
                                            {{item.yieldRate > 0 ? '+' : ''}}{{ item.yieldRate * 100 | toDigit(2) }}%
                                        </span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
              </div>
          </div>
      </div>
      <div class="tip">
        <p>发放说明：</p>
        <p>奖励将在比赛结束的次日的18：00前发放，请您耐心等待。</p>
      </div>
  </div>
</template>

<script>
import { parseTime } from '@/commons/tools.js'
export default {
    name: 'TeamPkResult2',
    data() {
        return {
            awardType: 'team',
            state: null,
            teamTime: null,
            updateTime: null,
            teamObj: {},
            personList: [],
            personAward: []
        }
    },
    watch: {
        // awardType(newVal) {
        //     this.getResult()
        // }
    },
    computed: {
        defaultImg() { return this.$DefaultHead }
    },
    mounted() {
        this.actId = this.$route.query.actId ? this.$route.query.actId : '306767'
        this.getResult()
        this.getPersonResult()
        this.getActInfo()
    },
    methods: {
        //  获取活动信息
        getActInfo() {
            this.$MyAxios.get('/api/trade/teams/rank', {}, response => {
                if(response.code == 1) {
                    this.showLoading = false
                    const data = response.data[0]
                    this.state = data.busState
                }
            })
        },

        //  获取战队结果
        getResult() {
            //  获取赛况直播内容
            this.$MyAxios.get('/api/trade/teams/award', {
                params: {
                    actId: this.actId,
                    ownerType: 'A'
                }
            }, response => {
                if(response.code == 1) {
                    this.showLoading = false
                    let teamAward = response.data[0]
                    this.teamTime = parseInt(teamAward.date)
                    this.updateTime = parseInt(teamAward.content[0].lastModifiedDate)
                    this.setTeamData(teamAward)
                }
            })
        },
        //  设置团队奖项
        setTeamData(teamAward) {
            let contentObj = teamAward.content
            const resultObj = {}
            for(let i = 0; i < contentObj.length; i++){
                const obj = contentObj[i]
                if(obj.level == -1) {
                    resultObj['four'] = {
                        name: obj.teamInfo ? obj.teamInfo.name : '-',
                        content: obj.content
                    }
                } else if (obj.level == 1) {
                    resultObj['one'] = {
                        name: obj.teamInfo ? obj.teamInfo.name : '-',
                        content: obj.content
                    }
                } else if (obj.level == 2) {
                    resultObj['two'] = {
                        name: obj.teamInfo ? obj.teamInfo.name : '-',
                        content: obj.content
                    }
                } else {
                    resultObj['three'] = {
                        name: obj.teamInfo ? obj.teamInfo.name : '-',
                        content: obj.content
                    }
                }
            }
            this.teamObj = resultObj
        },

        //  获取个人奖项
        getPersonResult() {
            //  获取赛况直播内容
            this.$MyAxios.get('/api/trade/award/memRankAndAward', {
                params: {
                    actId: this.actId,
                }
            }, response => {
                if(response.code == 1) {
                    this.showLoading = false
                    this.personList = response.data.topData
                    this.personAward = response.data.awardData
                }
            })
        },

        parseTime(time) {
            return parseTime(time)
        }
    }
}
</script>

<style lang="less" scoped>
#pk-result2 {
    padding-top: 60px;
    padding-bottom: 100px;
}
.award-tab-wrapper {
    height: 88px;
    width: 600px;
    border-radius: 88px;
    background: #EBECF0;
    margin: 0 auto;
    margin-bottom: 30px;
    button {
        border: none;
        background-color: #EBECF0;
        outline: none;
        color: #9598A6;
        font-size: 32px;
        font-weight: bold;
        height: 88px;
        width: 300px;
        border-radius: 88px;
        &.active {
            background: linear-gradient(180deg,#ffa41f, #ff5c2a);
            color: #FFFFFF;
        }
    }
}
.intro {
    line-height: 48px;
    font-size: 28px;
    color: #33333A;
    padding: 0 30px;
    margin-bottom: 40px;
    text-align: left;
}
.title-box {
    height: 40px;
    line-height: 40px;
    text-align: center;
    margin-bottom: 30px;
    img, span {
        vertical-align: middle;
    }
    img {
        margin: 0 5px;
        width: 44px;
        height: 24px;
    }
    span {
        font-size: 32px;
        color: #33333A;
        font-weight: bold;
    }
}
.person {
    padding-bottom: 10px;
    .award-info-person {
        // padding: 0 30px;
        .person-time {
            font-size: 32px;
            line-height: 45px;
            margin-bottom: 10px;
            text-align: center;
            font-weight: bold;
        }
    }
    .award-card {
        height: auto;
    }
    .card-body {
        height: 100px;
    }
    .days {
       width: 200px;
       font-size: 24px;
       font-weight: bold;
    }
    .name {
        width: 310px;
        color: #33333A;
        &>div {
            height: 72px;
            position: relative;
            padding-left: 80px;
            text-align: left;
        }
        img {
            position: absolute;
            top: 6px;
            left: 5px;
            height: 60px;
            width: 60px;
            border-radius: 30px;
        }
        p {
            font-size: 24px;
            line-height: 36px;
        }
        .nick {
            font-weight: bold;
        }
    }
    .content {
        width: 180px;
        font-size: 24px;
        font-weight: bold;
    }
    .line {
        &.first {
            left: 310px;
        }
        &.second {
            left: 510px;
        }
    }
}
.team {
    padding-bottom: 10px;
    margin-bottom: 20px;
    .award-info-team {
        padding: 0 30px;
        .time {
            font-size: 32px;
            line-height: 36px;
            margin-bottom: 30px;
            text-align: center;
            color: #ffa41f;
            font-weight: bold;
        }
        
    }
    .award-card {
        height: 490px;
        margin-bottom: 10px;
    }
    .card-body {
        height: 140px;
    }
    .rank {
       width: 160px;
       img {
           height: 42px;
           width: 42px;
       }
       h3 {
           font-size: 24px;
           line-height: 36px;
       } 
    }
    .name {
        width: 260px;
        color: #33333A;
        p {
            font-size: 24px;
            line-height: 36px;
            font-weight: bold;
        }
        .nick {
            font-weight: bold;
        }
    }
    .content {
        width: 270px;
        font-size: 24px;
        line-height: 36px;
        text-align: center;
    }
    .line {
        &.first {
            left: 159px;
        }
        &.second {
            left: 419px;
        }
    }
    .update-time {
        color: #9598A6;
        font-size: 24px;
        line-height: 36px;
        text-align: left;
    }
}
.award-card {
    width: 690px;
    margin: 0 auto;
    border: 1px solid #FFA41F;
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 60px;
    position: relative;
    &>div:last-of-type {
        border-bottom: 0;
    }
    .card-row {
        display: flex;
        display: -webkit-flex;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid #FFA41F;
        
        &>span {
            flex-grow: 1;
        }
    }
    .card-head {
        height: 70px;
        background: #FFF6E8;
        color: #33333A;
        font-size: 28px;
    }
    .line {
        position: absolute;
        height: 100%;
        width: 1px;
        background: #FFA41F;
        top: 0;
    }
}
.list-wrapper {
    text-align: right;
    margin-bottom: 40px;
    span {
        display: inline-block;
    }
    .list-head {
        height: 70px;
        color: #9598A6;
        border-top: 1px solid #EBECF0;
        border-bottom: 1px solid #EBECF0;
        padding: 0 30px;
        line-height: 70px;
        font-size: 24px;
    }
    .list-body {
        padding: 0 20px;
        
        li {
            padding: 0 10px;
            border-bottom: 1px solid #EBECF0;
            height: 120px;
            line-height: 120px;
            overflow: hidden;
            color: #33333A;
            font-weight: 500;
            div {
                position: relative;
                span {
                    position: relative;
                }
            }
            .name-part {
                overflow: hidden;
                position: relative;
                span {
                    width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .name-box {
                    position: relative;
                    height: 120px;
                    padding: 18px 0 18px 80px;
                    p {
                        font-size: 28px;
                        font-weight: 500px;
                        line-height: 42px;
                    }
                    .u-id {
                        color: #33333A;
                    }
                    .u-name {
                        color: #9598A6;
                    }
                    img.ava {
                        position: absolute;
                        top: 30px;
                        left: 0;
                        width: 60px;
                        height: 60px;
                        border-radius: 30px;
                    }
                }
            }
        }
        
    }
    .name-part {
        width: 50%;
        text-align: left;
    }
    .date-time {
        width: 24%;
        margin-right: 1%;
        text-align: left;
    }
    .incomeRate {
        width: 25%;
    }
}
.tip {
    text-align: left;
    line-height: 48px;
    font-size: 28px;
    color: #33333A;
    padding: 0 30px;
}
</style>